"use client";

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";

export default function SubdomainRedirect() {
  const searchParams = useSearchParams();
  
  useEffect(() => {
    const redirectToSubdomain = searchParams?.get("redirect_to_subdomain");
    
    if (redirectToSubdomain) {
      // Get the base domain (e.g., endure.health)
      const host = window?.location?.host;
      const baseDomain = host.split('.').slice(-2).join('.');
      
      // Create the subdomain URL
      const protocol = window?.location?.protocol;
      const newUrl = `${protocol}//${redirectToSubdomain}.${baseDomain}`;
      
      // Redirect to the subdomain
      if (window?.location) { window.location.href = newUrl; }
    }
  }, [searchParams]);
  
  return null;
}